import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import Redirectioneaza from './views/redirectioneaza'
import Ambassadors from './views/ambassadors'
import Join from './views/join'
import Founders from './views/founders'
import Home from './views/home'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={Redirectioneaza} exact path="/redirectioneaza" />
        <Route component={Ambassadors} exact path="/ambassadors" />
        <Route component={Join} exact path="/join" />
        <Route component={Founders} exact path="/founders" />
        <Route component={Home} exact path="/" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
